module.exports = __webpack_public_path__ + "img/ico-12-active.3f6eaa67.svg";